import { createAction } from "@reduxjs/toolkit";
 
export const apiCallBegan = createAction < any | undefined > ("api/callBegan");

export const apiCallSuccess = createAction < any | undefined > ("api/callSuccess");
export const apiCallFailed = createAction < any | undefined > ("api/callFailed");
export const apiNonCallChange = createAction < any | undefined > ("api/NonCallChange");